import * as React from 'react';
import { TextInput, Textarea } from "soprasteria-ui-library";
import { IEmergencyTreatmentReport } from "../../../models/IEmergencyTreatment";

interface IEmergencyTreatmentOtherInfo {
    emergencyTreatmentReport?: IEmergencyTreatmentReport;
}

export const EmergencyTreatmentOtherInfo: React.FunctionComponent<IEmergencyTreatmentOtherInfo> = ({ emergencyTreatmentReport }) => {

    return (
        <div className="row">
            <h5 className="col-12">Annat</h5>
            <div className="col-6">
                <TextInput
                    name="externalId"
                    label="Eget referens-ID"
                    defaultValue={emergencyTreatmentReport?.externalId ?? ""}
                    inlineLabel readonly={emergencyTreatmentReport ? emergencyTreatmentReport.isRegistered : true} />
                <Textarea
                    rows={6}
                    name="extraInfo"
                    label="Övriga uppgifter"
                    defaultValue={emergencyTreatmentReport?.extraInfo}
                    maxLength={4000}
                    inlineLabel readonly={emergencyTreatmentReport ? emergencyTreatmentReport.isRegistered : true} />
            </div>
        </div>
    )
}